
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import zoomIcon from '../../../../assets/images/zoom-icon.png';
import dayCalc from '../../../../utilities/dayCalcAlgorithm';
import { timeDifferenceCalculator } from 'time-difference-calculator';
import moment from 'moment-timezone';
import { toast, ToastContainer } from 'react-toastify';
import api from '../../../../services/api';
import VideoJoinModalClient from '../../../Coach/Chat/Modals/VideoJoinModalClient';
import ReactTimeAgo from 'react-time-ago';
import { useCallback } from 'react';
import { useUpdateBookingStatusMutation } from '../../../../services/chatApi';
import { useOpenChatMutation } from '../../../../services/chatApi'

const TimeRemaining = () => {

    const sessionDate = useSelector(state => state.coachReducer.sessionDate);
    const currentChatUser = useSelector(state => state.coachReducer);

const userDetails=useSelector(state=>state.userReducer)

const savedCoachTimeSlot = localStorage.getItem('coach_time_slot');


let sessionDurationMinutes = 60; // default
if (savedCoachTimeSlot) {
  // Extract number from string like "60_min"
  const match = savedCoachTimeSlot.match(/\d+/);
  if (match) {
    sessionDurationMinutes = parseInt(match[0], 10);
  }
}

 const daysRemaining = dayCalc(new Date(sessionDate), new Date());
    const [videoLink, setvideoLink] = useState(null);
    const [videoModal, setvideoModal] = useState(false);
    const [barStyle, setbarStyle] = useState("");
const [updateBookingStatus]=useUpdateBookingStatusMutation();
  


const handleCloseModal = useCallback(() => {
    // console.log("ddd");
    
  setvideoModal(false);
}, []);

const convertToUserTimezone = (date, time, timezone) => {
  if (!date || !time || !timezone) return null;

  try {
    const utcTime = moment.utc(`${date} ${time}`, 'YYYY-MM-DD HH:mm');
    return utcTime.tz(timezone);
  } catch (err) {
    // console.error("Timezone conversion error:", err);
    return null;
  }
};
 const deviceTimezone = localStorage.getItem('device_timezone')
const userTimezone = userDetails?.user?.data?.timezone?.name || deviceTimezone;


const handleVideoCall = () => {
  const sessionMoment = convertToUserTimezone(
    currentChatUser?.sessionDate,
    currentChatUser?.sessionTime,
    userTimezone
  );
  const now = moment();
  const sessionDiffInMinutes = sessionMoment.diff(now, 'minutes');

  if (sessionDiffInMinutes > 1) {
    toast.warn(`Your session has not started yet!`);
   
   
  } 
  else if (sessionDiffInMinutes < -sessionDurationMinutes) {
    toast.warn(`Your session is already completed!`);
   
   
  } 
  else {
    api
      .get(`common/get-booking-link/${currentChatUser?.last_message?.booking_id}`, {
        headers: {
          authorization: `Bearer ${localStorage.getItem("livtoken")}`,
        },
      })
      .then((res) => {
        // console.log("videores",res);
        
        try {
          const parsed = JSON.parse(res.data.data.zoom_link);
          // console.log(parsed);
          
          setvideoLink(parsed.url);
          setvideoModal(true);

        } catch (err) {
          toast.warn(`Failed to load video link.`);
        }
        const formData = new FormData()
        formData.append('person_id',currentChatUser.coach_id )
        formData.append('booking_id', currentChatUser?.last_message?.booking_id )

     updateBookingStatus(formData)
      .then((data) => {
        
      });
      })
      .catch(() => {
        toast.warn(`Some error occurred while fetching link.`);
      })
      .finally(() => {
       
      });
  }
};

const formatDate = (rawDate) => {
  const [year, month, day] = rawDate.split('-');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
    useEffect(() => {
        const now = moment();
        const sessionMoment = moment(`${currentChatUser?.sessionDate} ${currentChatUser?.sessionTime}`, "YYYY-MM-DD HH:mm");
        const diffDays = now.diff(sessionMoment, 'days');


        if (diffDays > 0) {
            setbarStyle("100%");
        } else if (diffDays < 0) {
            setbarStyle(`${100 / parseInt(timeDifferenceCalculator(currentChatUser?.sessionDate + " " + currentChatUser?.sessionTime).split(" ")[0])}%`);
        } else {
            const diffHours = now.diff(sessionMoment, 'hours');
            setbarStyle(diffHours >= 0 ? "100%" : `${100 / Math.abs(diffHours)}%`);
        }
    }, [currentChatUser]);

return (
        <div className="flex font-ubuntu bg-[#FFDBB0] rounded-[40px] w-max xl:ml-16 h-8 items-center">
            <div className="bg-white overflow-hidden rounded-2xl h-2 w-12 xl:w-12 my-auto ml-4 relative">
                <div style={{ width: barStyle }} className="absolute bg-orange h-full top-0 left-0" />
            </div>
<p className="flex-1 font-normal text-[8px] xl:text-[13px] mx-3">
  {currentChatUser?.sessionDate && currentChatUser?.sessionTime ? (
    (() => {
      const converted = convertToUserTimezone(
        currentChatUser?.sessionDate,
        currentChatUser?.sessionTime,
        userTimezone
      );
      return converted ? (
        <ReactTimeAgo
         key={converted?.toDate()?.getTime()}
          date={converted.toDate()}
          locale="en-US"
          timeStyle="round-minute"
        />
      ) : (
        <span className="text-sm text-gray-500">Invalid session time</span>
      );
    })()
  ) : (
    <span className="text-sm text-gray-500">Session time unavailable</span>
  )}
</p>
            <div className="flex-none">
                <img
                    src={zoomIcon}
                    onClick={handleVideoCall}
                    alt="video"
                    className="border-[#FFFFFF] w-[35px] h-[35px] border-[2px] rounded-3xl cursor-pointer"
                />
            </div>

            {videoModal &&
                <VideoJoinModalClient
                onCloseModal={handleCloseModal}
                    
                    videoLink={videoLink}
                    currentChatUser={currentChatUser}
                />
            }
            {/* <ToastContainer /> */}
        </div>
    );
};

export default TimeRemaining;


